import React, { Component } from "react"
import { ContentEditable } from "./content-editable"
import PropTypes from "prop-types"

const Spinner = () => (
  <div className="formkit-spinner">
    <div />
    <div />
    <div />
  </div>
)

export class ButtonElement extends Component {
  static propTypes = {
    className: PropTypes.string,
    input_type: PropTypes.oneOf(["button"]),
    name: PropTypes.string,
    onClick: PropTypes.func,
    style: PropTypes.object
  }

  render() {
    const { className, name, style, input_type, ...props } = this.props

    const Tag = props.editing ? "div" : "button"

    const attrs = !props.editing ? { type: input_type } : {}

    return (
      <Tag
        data-element={name}
        className={`formkit-${name} ${className || ""}`}
        style={style}
        onClick={this.props.onClick}
        {...attrs}
      >
        <Spinner />
        <ContentEditable {...props} tag="span" />
      </Tag>
    )
  }
}
